import React from 'react';
import { Radio, RadioProps } from '@mui/material';
import { createSvgIcon } from '@mui/material/utils';

import { theme } from '../../../styles/theme';

const AppRadio: React.FC<Readonly<RadioProps>> = (props) => {
  const circleFillColor = theme.palette.appWhite;
  const checkedColor = theme.palette.questionsForm.formBlue;
  const uncheckedColor = theme.palette.questionsForm.formInputUnselected;

  const CustomUnCheckedRadioIcon = createSvgIcon(
    <circle
      cx="12"
      cy="12"
      r="8.5"
      fill={circleFillColor}
      stroke={uncheckedColor}
      strokeWidth="1.3"
    />,
    'CustomUnCheckedRadioIcon'
  );

  const CustomCheckedRadioIcon = createSvgIcon(
    <>
      <circle
        cx="12"
        cy="12"
        r="8.5"
        fill={circleFillColor}
        stroke={checkedColor}
        strokeWidth="1.3"
      />
      <circle cx="12" cy="12" r="4.5" fill={checkedColor} />
    </>,
    'CustomCheckedRadioIcon'
  );

  return (
    <Radio
      {...props}
      icon={<CustomUnCheckedRadioIcon />}
      checkedIcon={<CustomCheckedRadioIcon />}
      disableRipple
      sx={{ padding: '4px' }}
    />
  );
};

export default AppRadio;
